<h1 *ngIf="!size || size == 1"><mat-icon *ngIf="icon">{{icon}}</mat-icon>{{text}}</h1>
<h2 *ngIf="size == 2"><mat-icon *ngIf="icon">{{icon}}</mat-icon>{{text}}</h2>
<h3 *ngIf="size == 3"><mat-icon *ngIf="icon">{{icon}}</mat-icon>{{text}}</h3>